const translations = {
    // Hero Section
    "unlock_cosmic": "ಶ್ರೀ ಆಸ್ಟ್ರೋ ವೇದ",
    "personalized_predictions": "ರಾಶಿ ಚಿಹ್ನೆಗಳಿಂದ ಜೀವನದ ದೊಡ್ಡ ಉತ್ತರಗಳವರೆಗೆ",
    "hero_description": "ಪ್ರಾಚೀನ ಜ್ಞಾನವು ನಿಮ್ಮ ಆಧುನಿಕ ಜೀವನವನ್ನು ಭೇಟಿ ಮಾಡುವ ಸ್ಥಳ — ಜನ್ಮ ಕುಂಡಲಿ, ಅಂಕಶಾಸ್ತ್ರ, ನಿಮ್ಮ ಪ್ರೇಮ ಜೀವನ ಮತ್ತು ದಶಾಫಲ ಪಠಣಗಳನ್ನು ಅನ್ವೇಷಿಸಿ, ಎಲ್ಲವೂ ಪ್ರಮಾಣಿತ ಜ್ಯೋತಿಷಿಗಳಿಂದ ನಿಮ್ಮ ಮಾರ್ಗವನ್ನು ಸ್ಪಷ್ಟತೆ ಮತ್ತು ಉದ್ದೇಶದೊಂದಿಗೆ ಮಾರ್ಗದರ್ಶನ ಮಾಡಲು ರಚಿಸಲಾಗಿದೆ.",
    "get_my_report": "ಪೂರ್ಣ ವರದಿ ಪಡೆಯಿರಿ",
    "view_sample": "ಮಾದರಿ ವರದಿ ನೋಡಿ",

    // Features
    "detailed_reports": "2026 ವೈಯಕ್ತಿಕ ಜೀವನ ವರದಿ",
    "horoscope_matching": "ಕುಂಡಲಿ ಹೊಂದಿಕೆ",
    "astrology_systems": "ಜನ್ಮ ಕುಂಡಲಿ, ಅಂಕಶಾಸ್ತ್ರ, ದಶಾ ಮತ್ತು ಇನ್ನಷ್ಟು",

    // Modal
    "200_pages": "200+ ಒಳನೋಟದ ಪುಟಗಳು",
    "20_years_predictions": "20 ವರ್ಷಗಳ ಭವಿಷ್ಯ ಭವಿಷ್ಯವಾಣಿ",
    "personalized_kundli": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವೇದಿಕ ಜೀವನ ವರದಿ",
    "most_detailed_india": "ಸಂಪೂರ್ಣ ಮತ್ತು ಸಮಗ್ರ ಮಾರ್ಗದರ್ಶನ",
    "cosmic_blueprint_description": "ನಿಮ್ಮ ಜೀವನ ಪ್ರಯಾಣವನ್ನು ಈ ಮೂಲಕ ವಿಶ್ಲೇಷಿಸಲಾಗಿದೆ:",

    "predictions_doshas_remedies": "ಜನ್ಮ ಕುಂಡಲಿ, ದಶಾ, ನಕ್ಷತ್ರ, ಅಂಕಶಾಸ್ತ್ರ, ಲಾಲ್ ಕಿತಾಬ್, ನಿಮ್ಮ ಪ್ರೇಮ ಜೀವನ, ವೃತ್ತಿ, ಆರೋಗ್ಯ ಸೂಚ್ಯಂಕ, ಸಾಡೆ ಸಾತಿ, ಪರಿಹಾರಗಳು ಮತ್ತು ಇನ್ನಷ್ಟು ಕುರಿತು ವಿವರವಾದ ಒಳನೋಟಗಳು.",
    "customized_for_you": "ಶ್ರೀಆಸ್ಟ್ರೋವೇದದಿಂದ ನಿಮಗಾಗಿ ವಿಶೇಷವಾಗಿ ರಚಿಸಲಾದ ದೈವಿಕ ವರದಿ",
    "check_sample_kundli": "ವರದಿ ಅನ್ವೇಷಿಸಿ",

    // Section Title & Description
    "authentic_vedic_astrology": "ಶ್ರೀಆಸ್ಟ್ರೋವೇದ ಜ್ಯೋತಿಷ್ಯ ಸೇವೆಗಳು",
    "cosmic_destiny": "ನಿಮ್ಮ ವಿಧಿ, ವಿಶ್ಲೇಷಣೆ ಮತ್ತು",
    "through_ancient_wisdom": "ವೇದ ಜ್ಯೋತಿಷ್ಯದ ಶಾಶ್ವತ ಜ್ಞಾನದಿಂದ ಮಾರ್ಗದರ್ಶನ",
    "two_section_description": "ಶ್ರೀಆಸ್ಟ್ರೋವೇದವು ಪ್ರಾಚೀನ ಜ್ಯೋತಿಷ್ಯ ಶಾಸ್ತ್ರದ ಮೂಲಕ — ವಿವರವಾದ ಕುಂಡಲಿ ವಿಶ್ಲೇಷಣೆ, ಅಂಕಶಾಸ್ತ್ರ, ದಶಾ ಟೈಮ್‌ಲೈನ್‌ಗಳು, ನಿಮ್ಮ ಪ್ರೇಮ ಜೀವನ ಮತ್ತು ಶಕ್ತಿಶಾಲಿ ಲಾಲ್ ಕಿತಾಬ್ ಪರಿಹಾರಗಳನ್ನು ಸಂಯೋಜಿಸಿ — ನೀವು ಜೀವನದಲ್ಲಿ ತಿಳಿದ ನಿರ್ಧಾರಗಳನ್ನು ತೆಗೆದುಕೊಳ್ಳಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ. ಸ್ಪಷ್ಟತೆ ಮತ್ತು ಆತ್ಮವಿಶ್ವಾಸದೊಂದಿಗೆ ನಿಮ್ಮ ಮಾರ್ಗವನ್ನು ಕಂಡುಕೊಳ್ಳಿ.",

    // Features – focused on user benefits
    "personalized_birth_charts": "ನಿಮ್ಮ ನಿಜವಾದ ಸ್ವಭಾವವನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ",
    "personalized_birth_charts_desc": "ನಿಮ್ಮ ಜನ್ಮ ಕುಂಡಲಿ, ಲಗ್ನ ಮತ್ತು ಗ್ರಹಸ್ಥಿತಿಗಳ ಸಂಪೂರ್ಣ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಪಡೆದು, ಮರೆವಲ್ಲಿರುವ ಶಕ್ತಿಗಳು, ದುರ್ಬಲತೆಗಳು ಮತ್ತು ಜೀವನ ಮಾದರಿಗಳನ್ನು ಅನಾವರಣಗೊಳಿಸಿ.",

    "remedial_gemstone_guidance": "ಜೀವನದ ಅಡೆತಡೆಗಳನ್ನು ಜಯಿಸಿ",
    "remedial_gemstone_guidance_desc": "ಗ್ರಹ ಅಸಮತೋಲನವನ್ನು ತಟಸ್ಥಗೊಳಿಸಲು ಪರಿಣಾಮಕಾರಿ ಪರಿಹಾರಗಳು, ರತ್ನ ಶಿಫಾರಸುಗಳು ಮತ್ತು ಸಾಡೆ ಸಾತಿ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಪಡೆಯಿರಿ.",

    "marriage_compatibility_analysis": "ಸಮರಸ ಸಂಬಂಧಗಳನ್ನು ಕಂಡುಕೊಳ್ಳಿ",
    "marriage_compatibility_analysis_desc": "ನಮ್ಮ ಸುಧಾರಿತ ಪ್ರೇಮ ಮತ್ತು ವಿವಾಹ ಹೊಂದಾಣಿಕೆ ಸಾಧನಗಳನ್ನು ಬಳಸಿಕೊಂಡು ಸಂಬಂಧದ ಚಲನೆಗಳನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ ಮತ್ತು ದೀರ್ಘಾವಧಿ ಹೊಂದಾಣಿಕೆಯನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ.",

    "career_life_predictions": "ಆತ್ಮವಿಶ್ವಾಸದೊಂದಿಗೆ ನಿಮ್ಮ ಭವಿಷ್ಯವನ್ನು ಯೋಜಿಸಿ",
    "career_life_predictions_desc": "ನಿಮ್ಮ ವೃತ್ತಿ, ಆರೋಗ್ಯ, ಹಣಕಾಸು ಮತ್ತು ವಾರ್ಷಿಕ ಪ್ರವೃತ್ತಿಗಳ ಬಗ್ಗೆ ನಿಖರವಾದ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ಪಡೆದು, ಮುಂಚಿತವಾಗಿ ಯೋಜಿಸಿ ಮತ್ತು ಶಕ್ತಿಯುತ ನಿರ್ಧಾರಗಳನ್ನು ತೆಗೆದುಕೊಳ್ಳಿ.",

    // CTA & Trust
    "start_your_journey": "ನಿಮ್ಮ ರಾಶಿ ಮಾರ್ಗವನ್ನು ಅನ್ಲಾಕ್ ಮಾಡಿ",
    "learn_more": "ಪೂರ್ಣ ಸೇವೆಗಳನ್ನು ಅನ್ವೇಷಿಸಿ",
    "rated_by_clients": "10,000+ ಗ್ರಾಹಕರಿಂದ 4.9/5 ರೇಟಿಂಗ್",
    "confidential_secure": "100% ಗೌಪ್ಯ ಮತ್ತು ಸುರಕ್ಷಿತ",

    "authentic_astrology_banner": "ಆಸಲಿ ಜ್ಯೋತಿಷ್ಯ ಸೇವೆಗಳು",

    "match_kundli": "ಕುಂಡಲಿ ಹೊಂದಿಸಿ",
    "match_kundli_desc": "ನಿಮ್ಮ ಮತ್ತು ನಿಮ್ಮ ಜೊತೆಯವರ ವಿವಾಹ ಹೊಂದಾಣಿಕೆ ಮತ್ತು ಕುಂಡಲಿ ಹೊಂದಾಣಿಕೆಯನ್ನು ಪರಿಶೀಲಿಸಿ.",
    "match_now": "ಈಗ ಹೊಂದಿಸಿ",

    "your_life_predictions": "ನಿಮ್ಮ ಜೀವನದ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "life_predictions_desc": "ನಿಮ್ಮ ಜನ್ಮಕುಂಡಲಿಯ ಆಧಾರದ ಮೇಲೆ ನಿಮ್ಮ ಭವಿಷ್ಯದ ಸಂಪೂರ್ಣ ಅವಲೋಕನವನ್ನು ಪಡೆಯಿರಿ.",
    "view_predictions": "ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ನೋಡಿ",

    "ask_question_price": "ಒಂದು ಪ್ರಶ್ನೆ ಕೇಳಿ",
    "ask_question_desc": "ಯಾವುದೇ ವೈಯಕ್ತಿಕ ಅಥವಾ ತುರ್ತು ಪ್ರಶ್ನೆಗೆ ತಜ್ಞರ ಉತ್ತರಗಳನ್ನು ಪಡೆಯಿರಿ.",
    "ask_now": "ಈಗ ಕೇಳಿ",

    "career_guidance": "ವೃತ್ತಿ",
    "career_desc": "ನಿಮ್ಮ ನಕ್ಷತ್ರಗಳ ಆಧಾರದ ಮೇಲೆ ಸರಿಯಾದ ವೃತ್ತಿ ಮಾರ್ಗ ಮತ್ತು ಉದ್ಯೋಗ ಅವಕಾಶಗಳನ್ನು ಕಂಡುಕೊಳ್ಳಿ.",
    "explore_career": "ವೃತ್ತಿಯನ್ನು ಅನ್ವೇಷಿಸಿ",

    "love_compatibility": "ಪ್ರೇಮ",
    "love_desc": "ನಿಮ್ಮ ಪ್ರೇಮ ಜೀವನ, ಸಂಬಂಧ ಹೊಂದಾಣಿಕೆ ಮತ್ತು ಭವಿಷ್ಯದ ಪ್ರೇಮವನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ.",
    "check_love_life": "ಪ್ರೇಮ ಜೀವನ ಪರಿಶೀಲಿಸಿ",

    "2026_personalized_report": "2026 ವೈಯಕ್ತಿಕ ವರದಿ",
    "2026_report_desc": "ನಿಮ್ಮ ಜನ್ಮವಿವರಗಳಿಗೆ ಹೊಂದಿಕೊಂಡ ವಾರ್ಷಿಕ ಭವಿಷ್ಯವಾಣಿ.",
    "get_2026_report": "2026 ವರದಿ ಪಡೆಯಿರಿ",

    "dasha_phal_analysis": "ದಶಾಫಲ ವಿಶ್ಲೇಷಣೆ",
    "dasha_analysis_desc": "ಗ್ರಹಗಳ ಅವಧಿಗಳು (ದಶಾ) ನಿಮ್ಮ ಜೀವನದ ಮೇಲೆ ಮಾಡುವ ಪರಿಣಾಮವನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ.",
    "analyze_now": "ಈಗ ವಿಶ್ಲೇಷಿಸಿ",

    "sade_sati_report": "ಸಾಡೆ ಸಾತಿ ಜೀವನ ವರದಿ",
    "sade_sati_desc": "ಶನಿ ಗ್ರಹದ ಸಾಡೆ ಸಾತಿ ನಿಮ್ಮ ಮೇಲೆ ಹೇಗೆ ಪರಿಣಾಮ ಬೀರುತ್ತದೆ ಎಂಬುದನ್ನು ಕಂಡುಕೊಳ್ಳಿ ಮತ್ತು ಪರಿಹಾರಗಳನ್ನು ಪಡೆಯಿರಿ.",
    "check_sade_sati": "ಸಾಡೆ ಸಾತಿ ಪರಿಶೀಲಿಸಿ",

    // Horoscope
    "free_daily_horoscope": "ಪ್ರತಿ ರಾಶಿ, ಪ್ರತಿ ರಹಸ್ಯ – ನಿಮ್ಮ ಬಗ್ಗೆ ನಕ್ಷತ್ರಗಳು ಏನು ಹೇಳುತ್ತವೆ ಎಂಬುದನ್ನು ತಿಳಿಯಿರಿ",
    "horoscope_categories": "",

    // Zodiac signs
    "aries": "ಮೇಷ",
    "taurus": "ವೃಷಭ",
    "gemini": "ಮಿಥುನ",
    "cancer": "ಕಟಕ",
    "leo": "ಸಿಂಹ",
    "virgo": "ಕನ್ಯಾ",
    "libra": "ತುಲಾ",
    "scorpio": "ವೃಶ್ಚಿಕ",
    "sagittarius": "ಧನು",
    "capricorn": "ಮಕರ",
    "aquarius": "ಕುಂಭ",
    "pisces": "ಮೀನ",

    // Date ranges
    "aries_dates": "ಮಾರ್ಚ್ 21 - ಏಪ್ರಿಲ್ 19",
    "taurus_dates": "ಏಪ್ರಿಲ್ 20 - ಮೇ 20",
    "gemini_dates": "ಮೇ 21 - ಜೂನ್ 20",
    "cancer_dates": "ಜೂನ್ 21 - ಜುಲೈ 22",
    "leo_dates": "ಜುಲೈ 23 - ಆಗಸ್ಟ್ 22",
    "virgo_dates": "ಆಗಸ್ಟ್ 23 - ಸೆಪ್ಟೆಂಬರ್ 22",
    "libra_dates": "ಸೆಪ್ಟೆಂಬರ್ 23 - ಅಕ್ಟೋಬರ್ 22",
    "scorpio_dates": "ಅಕ್ಟೋಬರ್ 23 - ನವೆಂಬರ್ 21",
    "sagittarius_dates": "ನವೆಂಬರ್ 22 - ಡಿಸೆಂಬರ್ 21",
    "capricorn_dates": "ಡಿಸೆಂಬರ್ 22 - ಜನವರಿ 19",
    "aquarius_dates": "ಜನವರಿ 20 - ಫೆಬ್ರವರಿ 18",
    "pisces_dates": "ಫೆಬ್ರವರಿ 19 - ಮಾರ್ಚ್ 20",

    // Modal content keys
    "today_horoscope": "ಇಂದಿನ ರಾಶಿ ಭವಿಷ್ಯ",
    "basic_info": "ಮೂಲಭೂತ ಮಾಹಿತಿ",
    "characteristics": "ಲಕ್ಷಣಗಳು",
    "lucky_elements": "ಅದೃಷ್ಟದ ಅಂಶಗಳು",
    "lucky_color": "ಅದೃಷ್ಟದ ಬಣ್ಣ",
    "lucky_number": "ಅದೃಷ್ಟದ ಸಂಖ್ಯೆ",
    "element": "ತತ್ತ್ವ",
    "ruling_planet": "ಆಡಳಿತ ಗ್ರಹ",
    "get_detailed_reading": "ವಿವರವಾದ ಓದು ಪಡೆಯಿರಿ",
    "more_insights": "ಇನ್ನಷ್ಟು ಒಳನೋಟಗಳು",
    "likes": "ಇಷ್ಟಗಳು",
    "dislikes": "ಅನಿಷ್ಟಗಳು",
    "food": "ಆಹಾರ",
    "travel_style": "ಪ್ರಯಾಣ ಶೈಲಿ",
    "movie_match": "ಚಿತ್ರ ಹೊಂದಾಣಿಕೆ",
    "song_vibe": "ಹಾಡಿನ ಭಾವ",
    "celebs": "ಪ್ರಸಿದ್ಧರು",

    // Aries content
    "aries_horoscope": "ಇಂದು ಉತ್ಸಾಹಭರಿತ ಶಕ್ತಿ ಮತ್ತು ಹೊಸ ಅವಕಾಶಗಳನ್ನು ತರುತ್ತದೆ. ನಿಮ್ಮ ನಾಯಕತ್ವ ಕೌಶಲ್ಯಗಳು ಹೊಳೆಯುತ್ತವೆ, ಹೊಸ ಯೋಜನೆಗಳನ್ನು ಪ್ರಾರಂಭಿಸಲು ಅಥವಾ ಪರಿಸ್ಥಿತಿಯನ್ನು ಹಿಡಿಯಲು ಇದು ಸೂಕ್ತ ದಿನ.",
    "aries_traits": "ಭಯವಿಲ್ಲದ, ಸ್ಪರ್ಧಾತ್ಮಕ, ಶಕ್ತಿಯುತ ಮತ್ತು ಮುಂದಾಳತ್ವದ. ಯಾವಾಗಲೂ ಮೊದಲು ಕ್ರಿಯಾಶೀಲರಾಗುವವರು.",
    "aries_likes": "ಗೆಲ್ಲುವುದು, ನಾಯಕತ್ವ, ಉತ್ಸಾಹ, ಸವಾಲುಗಳು.",
    "aries_dislikes": "ಸೋಮಾರಿತನ, ವಿಳಂಬ, ನಿರ್ಧಾರಹೀನತೆ.",
    "aries_food": "ಕಾರದ ಆಹಾರ, ಗ್ರಿಲ್ ಮಾಡಿದ ಮಾಂಸ, ಪ್ರೋಟೀನ್‌ ಸಮೃದ್ಧ ಆಹಾರ.",
    "aries_travel_style": "ಸಾಹಸ ಕ್ರೀಡೆಗಳು, ಏಕಾಂಗಿಯಾಗಿ ಟ್ರೆಕ್ಕಿಂಗ್, ರಸ್ತೆ ಪ್ರಯಾಣಗಳು.",
    "aries_movie_match": "ಮ್ಯಾಡ್ ಮ್ಯಾಕ್ಸ್: ಫ್ಯುರಿ ರೋಡ್",
    "aries_song_vibe": "ಐ ಆಫ್ ದ ಟೈಗರ್",
    "aries_celebs": "ಲೇಡಿ ಗಾಗಾ, ಅಜಯ್ ದೇವಗನ್, ರಾಬರ್ಟ್ ಡೌನಿ ಜೂನಿಯರ್",
    "aries_color": "ಕೆಂಪು",
    "aries_number": "9",
    "aries_element": "ಅಗ್ನಿ",
    "aries_planet": "ಮಂಗಳ",

    "taurus_horoscope": "ಇಂದು ಆನಂದ ಮತ್ತು ಸುಖಭೋಗದ ದಿನ. ಸ್ಥಿರತೆಯ ಮೇಲೆ ಗಮನ ಕೇಂದ್ರಿಸಿ ಮತ್ತು ಜೀವನದ ಉತ್ತಮ ವಿಷಯಗಳನ್ನು ಆನಂದಿಸಿ. ನಿಮ್ಮ ತಾಳ್ಮೆಗೆ ನೀರ್ಚಿರೋಧರ ಫಲಿತಾಂಶಗಳಿಂದ ಪ್ರತಿಫಲ ಸಿಗುತ್ತದೆ.",
    "taurus_traits": "ಶಾಂತ, ವಿಶ್ವಾಸಾರ್ಹ, ಇಂದ್ರಿಯ ಆಸಕ್ತಿ, ನಿಷ್ಠಾವಂತ. ಸೌಕರ್ಯ ಮತ್ತು ಐಷಾರಾಮಿ ಪ್ರೀತಿಸುತ್ತಾರೆ.",
    "taurus_likes": "ಪ್ರಕೃತಿ, ಸಂಗೀತ, ಉತ್ತಮ ಆಹಾರ, ಉತ್ತಮ ವಸ್ತುಗಳು.",
    "taurus_dislikes": "ಹಠಾತ್ ಬದಲಾವಣೆ, ವೇಗದ ಒತ್ತಡ, ಅಸ್ಥಿರತೆ.",
    "taurus_food": "ಸಮೃದ್ಧ ಊಟ, ಮಿಠಾಯಿಗಳು, ರುಚಿಕರ ಚೀಸ್, ಚಾಕೊಲೇಟ್‌ಗಳು.",
    "taurus_travel_style": "ಪ್ರಕೃತಿ ಆಶ್ರಯ, ದ್ರಾಕ್ಷಿ ತೋಟಗಳು, ಐಷಾರಾಮಿ ರೆಸಾರ್ಟ್‌ಗಳು.",
    "taurus_movie_match": "ದಿ ಹಂಡ್ರೆಡ್-ಫುಟ್ ಜರ್ನಿ",
    "taurus_song_vibe": "ಆಲ್ ಆಫ್ ಮಿ",
    "taurus_celebs": "ಗಿಗಿ ಹದೀದ್, ವರುಣ್ ಧವನ್, ಅಡೆಲೆ",
    "taurus_color": "ಹಸಿರು ಮತ್ತು ಗುಲಾಬಿ",
    "taurus_number": "೬",
    "taurus_element": "ಭೂಮಿ",
    "taurus_planet": "ಶುಕ್ರ",
    
    "gemini_horoscope": "ಇಂದು ಸಂವಹನವೇ ಮುಖ್ಯ. ನಿಮ್ಮ ಬುದ್ಧಿವಂತಿಕೆ ಮತ್ತು ಹೊಂದಿಕೊಳ್ಳುವಿಕೆ ಹೊಸ ಬಾಗಿಲುಗಳನ್ನು ತೆರೆಯುತ್ತದೆ. ನೆಟ್‌ವರ್ಕಿಂಗ್ ಮತ್ತು ಆಲೋಚನೆಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಲು ಸೂಕ್ತ ಸಮಯ.",
    "gemini_traits": "ಸಾಮಾಜಿಕ, ಹಾಸ್ಯಾಸ್ಪದ, ಹೊಂದಿಕೊಳ್ಳುವ, ವೇಗದ ಚಿಂತಕರು, ಬಹು-ಕಾರ್ಯಗಾರರು.",
    "gemini_likes": "ಮಾತನಾಡುವುದು, ಬರೆಯುವುದು, ತಂತ್ರಜ್ಞಾನ, ಹೊಸ ಅನುಭವಗಳು.",
    "gemini_dislikes": "ಪುನರಾವರ್ತನೆ, ಬೇಸರ, ಮೌನತೆ.",
    "gemini_food": "ಫಿಂಗರ್ ಫುಡ್, ಬೀದಿ ಲಘು ಆಹಾರ, ವಿಚಿತ್ರ ಭಕ್ಷ್ಯಗಳು.",
    "gemini_travel_style": "ಸಣ್ಣ ಆಕಸ್ಮಿಕ ಪ್ರವಾಸಗಳು, ನಗರ ಅನ್ವೇಷಣೆ.",
    "gemini_movie_match": "ದಿ ಸೋಶಿಯಲ್ ನೆಟ್‌ವರ್ಕ್",
    "gemini_song_vibe": "ಲೆವಿಟೇಟಿಂಗ್",
    "gemini_celebs": "ಏಂಜೆಲಿನಾ ಜೋಲಿ, ಕರಣ್ ಜೋಹರ್, ಕನ್ಯೆ ವೆಸ್ಟ್",
    "gemini_color": "ಹಳದಿ",
    "gemini_number": "೫",
    "gemini_element": "ವಾಯು",
    "gemini_planet": "ಬುಧ",
    
    "cancer_horoscope": "ಇಂದು ನಿಮ್ಮ ಅಂತಃಪ್ರಜ್ಞೆಯನ್ನು ನಂಬಿರಿ. ಕುಟುಂಬ ಮತ್ತು ಮನೆ ವಿಷಯಗಳಿಗೆ ಆದ್ಯತೆ ಕೊಡಿ. ನಿಮ್ಮ ಪೋಷಣೆಯ ಸ್ವಭಾವ ಸುತ್ತಲಿನವರಿಗೆ ಸಾಂತ್ವನೆ ತರುತ್ತದೆ.",
    "cancer_traits": "ಆಳವಾದ ಭಾವನಾತ್ಮಕ, ಪೋಷಣೆ ಮಾಡುವ, ಅಂತಃಪ್ರಜ್ಞೆ ಹೊಂದಿದ, ಕುಟುಂಬ-ಆಧಾರಿತ.",
    "cancer_likes": "ಮನೆ, ಸಾಂತ್ವನಾ ಆಹಾರ, ನೆನಪುಗಳು, ಆಪ್ತ ಸ್ನೇಹಿತರು.",
    "cancer_dislikes": "ಕಠೋರತೆ, ತ್ಯಾಗ, ಬದಲಾವಣೆ.",
    "cancer_food": "ಮನೆಯ ಊಟ, ಅನ್ನ ಪದಾರ್ಥಗಳು, ಮಿಠಾಯಿಗಳು.",
    "cancer_travel_style": "ಸಮುದ್ರ ತೀರದ ಮನೆಗಳು, ಪೂರ್ವಜರ ಸ್ಥಳಗಳು, ಆಧ್ಯಾತ್ಮಿಕ ಆಶ್ರಯಗಳು.",
    "cancer_movie_match": "ದಿ ನೋಟ್‌ಬುಕ್",
    "cancer_song_vibe": "ಫೋಟೋಗ್ರಾಫ್",
    "cancer_celebs": "ಸೆಲೆನಾ ಗೋಮೆಜ್, ಪ್ರಿಯಾಂಕಾ ಚೋಪ್ರಾ, ಟಾಮ್ ಹ್ಯಾಂಕ್ಸ್",
    "cancer_color": "ಬಿಳಿ ಮತ್ತು ಬೆಳ್ಳಿ",
    "cancer_number": "೨",
    "cancer_element": "ಜಲ",
    "cancer_planet": "ಚಂದ್ರ",
    
    "leo_horoscope": "ಇಂದು ನಿಮ್ಮ ನೈಸರ್ಗಿಕ ಆಕರ್ಷಣೆ ಹೊಳೆಯುತ್ತದೆ. ಕೇಂದ್ರ ವೇದಿಕೆಯನ್ನು ಪಡೆದುಕೊಂಡು ನಿಮ್ಮ ಸೃಜನಶೀಲತೆಯನ್ನು ಹರಿಯಲಿ. ಗುರುತಿಸುವಿಕೆ ಮತ್ತು ಪ್ರಶಂಸೆ ನಿಮ್ಮ ಕಡೆಗೆ ಬರುತ್ತಿದೆ.",
    "leo_traits": "ಧೈರ್ಯಶಾಲಿ, ನಾಟಕೀಯ, ಹೃದಯವಂತ, ಜನ್ಮಜಾತ ನಾಯಕ. ಗಮನ ಕೇಂದ್ರೀಕರಣ ಬಯಸುತ್ತಾರೆ.",
    "leo_likes": "ಗ್ಲಾಮರ್, ವೇದಿಕೆ, ಆಚರಣೆಗಳು, ನಾಯಕತ್ವ.",
    "leo_dislikes": "ನಿರ್ಲಕ್ಷ್ಯ, ನೀರಸತೆ, ಟೀಕೆ.",
    "leo_food": "ಗ್ರಿಲ್ಡ್ ಆಹಾರ, ಸಮೃದ್ಧ ಮಿಠಾಯಿಗಳು, ವಿದೇಶಿ ಭಕ್ಷ್ಯಗಳು.",
    "leo_travel_style": "ಐಷಾರಾಮಿ ಕ್ರೂಸ್‌ಗಳು, ಸಾಂಸ್ಕೃತಿಕ ಮೆರವಣಿಗೆಗಳು, ಸ್ಪಾಟ್‌ಲೈಟ್ ಗಮ್ಯಸ್ಥಾನಗಳು.",
    "leo_movie_match": "ದಿ ಗ್ರೇಟ್ ಗ್ಯಾಟ್ಸ್‌ಬಿ",
    "leo_song_vibe": "ಅಪ್‌ಟೌನ್ ಫಂಕ್",
    "leo_celebs": "ಜೆನ್ನಿಫರ್ ಲೋಪೆಜ್, ಸೈಫ್ ಅಲಿ ಖಾನ್, ಬರಾಕ್ ಒಬಾಮಾ",
    "leo_color": "ಚಿನ್ನ ಮತ್ತು ಕಿತ್ತಳೆ",
    "leo_number": "೧",
    "leo_element": "ಅಗ್ನಿ",
    "leo_planet": "ಸೂರ್ಯ",
    
    "virgo_horoscope": "ಇಂದು ವಿವರಗಳಿಗೆ ಗಮನ ಫಲ ನೀಡುತ್ತದೆ. ನಿಮ್ಮ ವಿಶ್ಲೇಷಣಾತ್ಮಕ ಕೌಶಲ್ಯಗಳು ಸಂಕೀರ್ಣ ಸಮಸ್ಯೆಗಳನ್ನು ಪರಿಹರಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ. ಆರೋಗ್ಯ ಮತ್ತು ಸಂಘಟನೆಯ ಮೇಲೆ ಗಮನ ಕೇಂದ್ರಿಸಿ.",
    "virgo_traits": "ಪರಿಪೂರ್ಣತಾವಾದಿ, ಪ್ರಾಯೋಗಿಕ, ಬುದ್ಧಿವಂತ, ಆರೋಗ್ಯ-ಜಾಗೃತ.",
    "virgo_likes": "ಶುಚಿತ್ವ, ಯೋಜನೆಗಳು, ಸಹಾಯ ಮಾಡುವುದು, ಕಲಿಯುವುದು.",
    "virgo_dislikes": "ಗೊಂದಲ, ಅಸಮರ್ಥತೆ, ಭಾವನಾತ್ಮಕ ಸ್ಫೋಟಗಳು.",
    "virgo_food": "ಆರೋಗ್ಯಕರ ಬೌಲ್‌ಗಳು, ಸ್ವಚ್ಛ ಆಹಾರ, ಸೂಪ್‌ಗಳು, ಸಲಾಡ್‌ಗಳು.",
    "virgo_travel_style": "ಕಲ್ಯಾಣ ರೆಸಾರ್ಟ್‌ಗಳು, ಪರಿಸರ ತಂಗಿಗೆಗಳು, ಪರಂಪರೆ ಸ್ಥಳಗಳು.",
    "virgo_movie_match": "ದಿ ಇಮಿಟೇಶನ್ ಗೇಮ್",
    "virgo_song_vibe": "ಲವ್ಲಿ",
    "virgo_celebs": "ಕೀನು ರೀವ್ಸ್, ಕರೀನಾ ಕಪೂರ್, ಜೆಂಡಾಯಾ",
    "virgo_color": "ಬಿಳಿ ಮತ್ತು ಮಣ್ಣಿನ ಬಣ್ಣಗಳು",
    "virgo_number": "೬",
    "virgo_element": "ಭೂಮಿ",
    "virgo_planet": "ಬುಧ",
    
    "libra_horoscope": "ಇಂದು ಸಾಮರಸ್ಯ ಮತ್ತು ಸಮತೋಲನ ನಿಮ್ಮ ದಿನವನ್ನು ಮಾರ್ಗದರ್ಶಿಸುತ್ತದೆ. ನ್ಯಾಯ ಮತ್ತು ಸೌಂದರ್ಯದ ಮೇಲೆ ಗಮನ ಕೇಂದ್ರಿಸಿದಾಗ ಸಂಬಂಧಗಳು ಅರಳುತ್ತವೆ. ಕಲಾತ್ಮಕ ಅನ್ವೇಷಣೆಗಳು ಆನಂದ ತರುತ್ತವೆ.",
    "libra_traits": "ಸುಂದರ, ನ್ಯಾಯಯುತ, ಪ್ರಣಯ, ಶಾಂತಿ-ಪ್ರೀತಿ, ಸೌಂದರ್ಯ.",
    "libra_likes": "ಕಲೆ, ಫ್ಯಾಷನ್, ಪ್ರಣಯ, ಸಂಭಾಷಣೆ.",
    "libra_dislikes": "ಅಸಭ್ಯತೆ, ವಾದಗಳು, ಅಸಮತೋಲನ.",
    "libra_food": "ಪೇಸ್ಟ್ರಿಗಳು, ವೈನ್, ಚೀಸ್, ಹಗುರ ಪಾಸ್ಟಾ.",
    "libra_travel_style": "ಪ್ಯಾರಿಸ್, ವೆನಿಸ್, ಪ್ರಣಯಭರಿತ ಅಥವಾ ಫ್ಯಾಷನ್ ಗಮ್ಯಸ್ಥಾನಗಳು.",
    "libra_movie_match": "ಲಾ ಲಾ ಲ್ಯಾಂಡ್",
    "libra_song_vibe": "ಜಸ್ಟ್ ದಿ ವೇ ಯು ಆರ್",
    "libra_celebs": "ಕಿಮ್ ಕಾರ್ದಾಶಿಯನ್, ರಣಬೀರ್ ಕಪೂರ್, ಹ್ಯೂ ಜಾಕ್‌ಮನ್",
    "libra_color": "ಆಕಾಶ ನೀಲಿ ಮತ್ತು ಗುಲಾಬಿ",
    "libra_number": "೭",
    "libra_element": "ವಾಯು",
    "libra_planet": "ಶುಕ್ರ",
    
    "scorpio_horoscope": "ಇಂದು ಆಳವಾದ ರೂಪಾಂತರ ಗಾಳಿಯಲ್ಲಿದೆ. ನಿಮ್ಮ ಪ್ರವೃತ್ತಿಯನ್ನು ನಂಬಿ ಬದಲಾವಣೆಯನ್ನು ಸ್ವೀಕರಿಸಿ. ನಿಮ್ಮ ತೀವ್ರತೆ ಮತ್ತು ಭಾವೋದ್ರೇಕ ಪ್ರಗತಿ ಕ್ಷಣಗಳಿಗೆ ದಾರಿ ಮಾಡುತ್ತದೆ.",
    "scorpio_traits": "ನಿಗೂಢ, ತೀವ್ರ, ನಿಷ್ಠಾವಂತ, ಭಾವನಾತ್ಮಕವಾಗಿ ಆಳವಾದ.",
    "scorpio_likes": "ರಹಸ್ಯಗಳು, ರೂಪಾಂತರ, ಭಾವೋದ್ರೇಕ.",
    "scorpio_dislikes": "ಅಪ್ರಾಮಾಣಿಕತೆ, ಆಳವಿಲ್ಲದ ಜನರು, ವಿಶ್ವಾಸಘಾತುಕತೆ.",
    "scorpio_food": "ಮಸಾಲೆಯುಕ್ತ, ಧೈರ್ಯದ ಸುವಾಸನೆಗಳು, ಡಾರ್ಕ್ ಚಾಕೊಲೇಟ್, ನಿಗೂಢ ಊಟ.",
    "scorpio_travel_style": "ಗುಪ್ತ ರತ್ನಗಳು, ಗುಹೆಗಳು, ರಹಸ್ಯ ಕಡಲತೀರಗಳು.",
    "scorpio_movie_match": "ಗಾನ್ ಗರ್ಲ್",
    "scorpio_song_vibe": "ಟೇಕ್ ಮಿ ಟು ಚರ್ಚ್",
    "scorpio_celebs": "ರಯಾನ್ ಗೋಸ್ಲಿಂಗ್, ಶಾರುಖ್ ಖಾನ್, ಕೇಟಿ ಪೆರ್ರಿ",
    "scorpio_color": "ಕಪ್ಪು ಮತ್ತು ಗಾಢ ಕೆಂಪು",
    "scorpio_number": "೮",
    "scorpio_element": "ಜಲ",
    "scorpio_planet": "ಮಂಗಳ ಮತ್ತು ಪ್ಲುಟೋ",
    
    "sagittarius_horoscope": "ಇಂದು ಸಾಹಸ ನಿಮ್ಮ ಹೆಸರನು್ನ ಕರೆಯುತ್ತಿದೆ. ಕಲಿಕೆ ಅಥವಾ ಪ್ರವಾಸದ ಮೂಲಕ ನಿಮ್ಮ ದೃಷ್ಟಿಕೋನವನ್ನು ವಿಸ್ತರಿಸಿ. ನಿಮ್ಮ ಆಶಾವಾದ ಇತರರಿಗೆ ದೊಡ್ಡ ಕನಸು ಕಾಣಲು ಪ್ರೇರಣೆ ನೀಡುತ್ತದೆ.",
    "sagittarius_traits": "ಮುಕ್ತ-ಮನಸ್ಸಿನ, ಹಾಸ್ಯಾಸ್ಪದ, ತಾತ್ವಿಕ, ಆಶಾವಾದಿ.",
    "sagittarius_likes": "ಪ್ರವಾಸ, ಸಾಹಸ, ಸತ್ಯ, ಆಳವಾದ ಸಂಭಾಷಣೆಗಳು.",
    "sagittarius_dislikes": "ನಿಯಮಗಳು, ಅಂಟಿಕೊಳ್ಳುವಿಕೆ, ದಿನಚರಿ.",
    "sagittarius_food": "ಬೀದಿ ಆಹಾರ, ಬಾರ್ಬೆಕ್ಯೂ, ಅಂತರರಾಷ್ಟ್ರೀಯ ಪಾಕಪದ್ಧತಿಗಳು.",
    "sagittarius_travel_style": "ಬ್ಯಾಕ್‌ಪ್ಯಾಕಿಂಗ್, ಆಫ್‌ಬೀಟ್ ಸಾಹಸಗಳು, ಏಕಾಂಗಿ ಪ್ರವಾಸಗಳು.",
    "sagittarius_movie_match": "ಇಂಟು ದಿ ವೈಲ್ಡ್",
    "sagittarius_song_vibe": "ಅಡ್ವೆಂಚರ್ ಆಫ್ ಎ ಲೈಫ್‌ಟೈಮ್",
    "sagittarius_celebs": "ಟೇಲರ್ ಸ್ವಿಫ್ಟ್, ಧರ್ಮೇಂದ್ರ, ಬ್ರಾಡ್ ಪಿಟ್",
    "sagittarius_color": "ನೇರಳೆ ಮತ್ತು ಮರಕತ",
    "sagittarius_number": "೯",
    "sagittarius_element": "ಅಗ್ನಿ",
    "sagittarius_planet": "ಗುರು",
    
    "capricorn_horoscope": "ಇಂದು ಕಠಿಣ ಪರಿಶ್ರಮ ಮತ್ತು ಶಿಸ್ತು ಯಶಸ್ಸನ್ನು ತರುತ್ತದೆ. ನಿಮ್ಮ ವ್ಯವಸ್ಥಿತ ವಿಧಾನ ದೀರ್ಘಕಾಲೀನ ಸಾಧನೆಗಳಿಗೆ ಬಾಗಿಲುಗಳನ್ನು ತೆರೆಯುತ್ತದೆ. ನಿಮ್ಮ ಗುರಿಗಳ ಮೇಲೆ ಗಮನ ಇರಿಸಿ.",
    "capricorn_traits": "ಮಹತ್ವಾಕಾಂಕ್ಷೆ, ಪ್ರಬುದ್ಧ, ಶಿಸ್ತುಬದ್ಧ, ಸಾಂಪ್ರದಾಯಿಕ.",
    "capricorn_likes": "ಯಶಸ್ಸು, ರಚನೆ, ನಿಷ್ಠೆ, ಪರಂಪರೆಗಳು.",
    "capricorn_dislikes": "ಆಲಸ್ಯ, ಅಪ್ರಾಮಾಣಿಕತೆ, ಶಾರ್ಟ್‌ಕಟ್‌ಗಳು.",
    "capricorn_food": "ಸಾಂಪ್ರದಾಯಿಕ ಊಟ, ಸೂಪ್‌ಗಳು, ಬ್ರೆಡ್‌ಗಳು, ನಿಧಾನ-ಬೇಯಿಸಿದ ಆಹಾರ.",
    "capricorn_travel_style": "ಬೆಟ್ಟಗಳು, ಐತಿಹಾಸಿಕ ನಗರಗಳು, ವ್ಯಾಪಾರ-ವಿರಾಮ ಪ್ರವಾಸಗಳು.",
    "capricorn_movie_match": "ದಿ ಪರ್ಸ್ಯೂಟ್ ಆಫ್ ಹ್ಯಾಪಿನೆಸ್",
    "capricorn_song_vibe": "ಹಾಲ್ ಆಫ್ ಫೇಮ್",
    "capricorn_celebs": "ದೀಪಿಕಾ ಪಾದುಕೋಣೆ, ಋತಿಕ್ ರೋಶನ್, ಮಿಚೆಲ್ ಒಬಾಮಾ",
    "capricorn_color": "ನೇವಿ ಮತ್ತು ಕಂದು",
    "capricorn_number": "೧೦",
    "capricorn_element": "ಭೂಮಿ",
    "capricorn_planet": "ಶನಿ",
    
    "aquarius_horoscope": "ಇಂದು ನಾವೀನ್ಯತೆ ಮತ್ತು ಮಾನವೀಯ ಪ್ರಯತ್ನಗಳು ಕೇಂದ್ರ ವೇದಿಕೆ ತೆಗೆದುಕೊಳ್ಳುತ್ತವೆ. ನಿಮ್ಮ ವಿಶಿಷ್ಟ ದೃಷ್ಟಿಕೋನ ಹಳೆಯ ಸಮಸ್ಯೆಗಳಿಗೆ ಹೊಸ ಪರಿಹಾರಗಳನ್ನು ತರುತ್ತದೆ. ಪೆಟ್ಟಿಗೆಯ ಹೊರಗೆ ಯೋಚಿಸಿ.",
    "aquarius_traits": "ದೃಷ್ಟಾಂತಿ, ಸ್ವತಂತ್ರ, ಅಸಾಂಪ್ರದಾಯಿಕ, ಮಾನವೀಯ.",
    "aquarius_likes": "ನಾವೀನ್ಯತೆ, ಸಾಮಾಜಿಕ ಕಾರಣಗಳು, ಆಲೋಚನೆಗಳು, ಸಮುದಾಯ.",
    "aquarius_dislikes": "ನಿರ್ಬಂಧಗಳು, ಅಮಾನವೀಯತೆ, ದಿನಚರಿ.",
    "aquarius_food": "ಸಸ್ಯಾಹಾರಿ/ಸಸ್ಯ-ಆಧಾರಿತ, ಫ್ಯೂಷನ್ ಆಹಾರ, ಸ್ಮೂತಿಗಳು.",
    "aquarius_travel_style": "ಭವಿಷ್ಯದ ನಗರಗಳು, ಸ್ವಯಂಸೇವಕ ಪ್ರವಾಸ, ಉದ್ದೇಶದೊಂದಿಗೆ ರೋಡ್ ಟ್ರಿಪ್‌ಗಳು.",
    "aquarius_movie_match": "ದಿ ಮ್ಯಾಟ್ರಿಕ್ಸ್",
    "aquarius_song_vibe": "ರೇಡಿಯೋಆಕ್ಟಿವ್",
    "aquarius_celebs": "ಓಪ್ರಾ ವಿನ್‌ಫ್ರೇ, ಪ್ರೀತಿ ಜಿಂಟಾ, ಹ್ಯಾರಿ ಸ್ಟೈಲ್ಸ್",
    "aquarius_color": "ಎಲೆಕ್ಟ್ರಿಕ್ ನೀಲಿ ಮತ್ತು ಜಲ",
    "aquarius_number": "೧೧",
    "aquarius_element": "ವಾಯು",
    "aquarius_planet": "ಯುರೇನಸ್ ಮತ್ತು ಶನಿ",
    
    "pisces_horoscope": "ಇಂದು ನಿಮ್ಮ ಕಲ್ಪನೆಯನ್ನು ಹರಿಯಲಿ. ಕನಸುಗಳು ಮತ್ತು ಅಂತಃಪ್ರಜ್ಞೆ ನಿಮ್ಮನ್ನು ಸುಂದರ ಆವಿಷ್ಕಾರಗಳಿಗೆ ಮಾರ್ಗದರ್ಶನ ಮಾಡುತ್ತದೆ. ನಿಮ್ಮ ಸಹಾನುಭೂತಿಯ ಸ್ವಭಾವ ಅನೇಕ ಹೃದಯಗಳನ್ನು ಸ್ಪರ್ಶಿಸುತ್ತದೆ.",
    "pisces_traits": "ಸಹಾನುಭೂತಿ, ಕನಸುಮಯ, ಕಲಾತ್ಮಕ, ಅಂತಃಪ್ರಜ್ಞೆ.",
    "pisces_likes": "ಕಲೆ, ಪ್ರೇಮಕಥೆಗಳು, ಸಂಗೀತ, ಕನಸುಗಳು.",
    "pisces_dislikes": "ಕಠೋರ ವಾಸ್ತವತೆಗಳು, ಗಾಯದ ಗುಂಪುಗಳು, ಸಂಘರ್ಷ.",
    "pisces_food": "ಸಮುದ್ರಾಹಾರ, ಪಾಸ್ಟಾ, ಸಾಂತ್ವನಾ ಆಹಾರ, ಐಸ್ ಕ್ರೀಮ್.",
    "pisces_travel_style": "ದ್ವೀಪಗಳು, ಆಶ್ರಯಗಳು, ನದಿ ತೀರದ ಪಲಾಯನಗಳು.",
    "pisces_movie_match": "ಲೈಫ್ ಆಫ್ ಪೈ",
    "pisces_song_vibe": "ಸಮ್ವನ್ ಲೈಕ್ ಯು",
    "pisces_celebs": "ರಿಹಾನ್ನಾ, ಆಲಿಯಾ ಭಟ್, ಜಸ್ಟಿನ್ ಬೀಬರ್",
    "pisces_color": "ಲೇವೆಂಡರ್ ಮತ್ತು ಸಮುದ್ರ ಹಸಿರು",
    "pisces_number": "೧೨",
    "pisces_element": "ಜಲ",
    "pisces_planet": "ನೆಪ್ಚೂನ್ ಮತ್ತು ಗುರು",
    
    "review_title": "ಶಕ್ತಿ ವಿನಿಮಯ: ಅವರ ಮಾತುಗಳು, ನಮ್ಮ ಕೃತಜ್ಞತೆ",
    "why_choose": "ಏಕೆ ಆಯ್ಕೆ ಮಾಡಬೇಕು",
    "sri_astro_veda": "ಶ್ರೀ ಆಸ್ಟ್ರೋ ವೇದ",
    
    "unlimited_kundlis_question": "ನಾನು ಬಹು ಕುಂಡಲಿಗಳನ್ನು ವಿನಂತಿಸಬಹುದೇ?",
    "unlimited_kundlis_answer": "ಹೌದು! ನಿಮಗೆ ಬೇಕಾದಷ್ಟು ವ್ಯಕ್ತಿಗಳ ವಿವರಗಳನ್ನು ನೀವು ಸಲ್ಲಿಸಬಹುದು. ಪ್ರತಿ ವಿನಂತಿಯನ್ನು ಎಚ್ಚರಿಕೆಯಿಂದ ತಯಾರಿಸಿ ವೈಯಕ್ತಿಕ PDF ವರದಿಯಾಗಿ ವಿತರಿಸಲಾಗುತ್ತದೆ.",
    "kundli_reports_question": "ಕುಂಡಲಿ ವರದಿಗಳಲ್ಲಿ ಏನು ಸೇರಿಸಲಾಗಿದೆ?",
    "kundli_reports_answer": "ಪ್ರತಿ ವರದಿಯು ವೃತ್ತಿಪರವಾಗಿ ತಯಾರಿಸಿದ PDF ಆಗಿದ್ದು, ಜನ್ಮ ಕುಂಡಲಿ, ಲಗ್ನ ವಿಶ್ಲೇಷಣೆ, ದಶೆ, ಗೋಚರ, ನಕ್ಷತ್ರ, ಸಂಖ್ಯಾಶಾಸ್ತ್ರ, ಪ್ರೇಮ ಮತ್ತು ವೃತ್ತಿ ಮಾರ್ಗದರ್ಶನ, ಆರೋಗ್ಯ ಸೂಚ್ಯಂಕ, ಲಾಲ್ ಕಿತಾಬ್ ಪರಿಹಾರಗಳು ಇತ್ಯಾದಿಗಳನ್ನು ಒಳಗೊಂಡಿದೆ.",
    "saving_notes_question": "ನಾನು ಸೆಷನ್ ಸಟಿಪ್ಪಣಿಗಳು ಅಥವಾ ಪರಿಹಾರಗಳನ್ನು ಸೇರಿಸಬಹುದೇ?",
    "saving_notes_answer": "ಖಂಡಿತವಾಗಿ. ನೀವು ನಿರ್ದಿಷ್ಟ ಪರಿಹಾರಗಳು, ಅನುಸರಣೆ ಟಿಪ್ಪಣಿಗಳು ಅಥವಾ ಹೆಚ್ಚುವರಿ ಅವಲೋಕನಗಳನ್ನು ಸೇರಿಸಲು ಬಯಸಿದರೆ, ನಿಮ್ಮ ವಿನಂತಿಯ ಸಮಯದಲ್ಲಿ ಅವುಗಳನ್ನು ಉಲ್ಲೇಖಿಸಿ.",
    "devices_question": "ನಾನು ವರದಿಯನ್ನು ಹೇಗೆ ಸ್ವೀಕರಿಸುತ್ತೇನೆ?",
    "devices_answer": "ನೀವು ೨೪ ಗಂಟೆಗಳೊಳಗೆ PDF ಸ್ವರೂಪದಲ್ಲಿ WhatsApp, ಇಮೇಲ್ ಅಥವಾ SMS ಮೂಲಕ ವರದಿಯನ್ನು ಸ್ವೀಕರಿಸುತ್ತೀರಿ - ನಿಮಗೆ ಬೇಕಾದ ವಿಧಾನ.",
    "data_safety_question": "ನನ್ನ ವೈಯಕ್ತಿಕ ಡೇಟಾ ಸುರಕ್ಷಿತವೇ?",
    "data_safety_answer": "ಹೌದು. ಎಲ್ಲಾ ಬಳಕೆದಾರರ ಡೇಟಾವನ್ನು ಸಂಪೂರ್ಣ ಗೌಪ್ಯವಾಗಿ ಇರಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಎಂದಿಗೂ ಹಂಚಿಕೊಳ್ಳಲಾಗುವುದಿಲ್ಲ. ನಿಮ್ಮ ಗೌಪ್ಯತೆ ಮತ್ತು ನಂಬಿಕೆ ನಮ್ಮ ಅತ್ಯುನ್ನತ ಆದ್ಯತೆಗಳು.",
    "advertising_question": "ವರದಿಯು ಜಾಹೀರಾತುಗಳಿಂದ ಮುಕ್ತವೇ?",
    "advertising_answer": "೧೦೦% ಜಾಹೀರಾತು-ಮುಕ್ತ. ನಮ್ಮ ವರದಿಗಳು ಯಾವುದೇ ಪ್ರಚಾರಾತ್ಮಕ ಗೊಂದಲಗಳಿಲ್ಲದೆ ಶುದ್ಧ, ಕೇಂದ್ರೀಕೃತ ಜ್ಯೋತಿಷ್ಯ ಸೂಚನೆಗಳನ್ನು ನೀಡಲು ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ.",
    "client_management_question": "ನಾನು ನನ್ನ ಗ್ರಾಹಕರಿಗಾಗಿ ವರದಿಗಳನ್ನು ಆರ್ಡರ್ ಮಾಡಬಹುದೇ?",
    "client_management_answer": "ಹೌದು! ನೀವು ಜ್ಯೋತಿಷಿ, ಸಲಹೆಗಾರ ಅಥವಾ ಕಲ್ಯಾಣ ತರಬೇತುದಾರರಾಗಿದ್ದರೂ, ನಿಮ್ಮ ಗ್ರಾಹಕರಿಗಾಗಿ ವೈಯಕ್ತಿಕ ವರದಿಗಳನ್ನು ಆರ್ಡರ್ ಮಾಡಬಹುದು. ಬೃಹತ್ ಮತ್ತು ಮರುಕಳುಹಿಸುವ ಆರ್ಡರ್‌ಗಳನ್ನು ಬೆಂಬಲಿಸಲಾಗುತ್ತದೆ.",
    "customize_charts_question": "ನಾನು ಚಾರ್ಟ್ ಶೈಲಿ ಅಥವಾ ಲೇಔಟ್ ಆಯ್ಕೆ ಮಾಡಬಹುದೇ?",
    "customize_charts_answer": "ಹೌದು. ನಾವು ಉತ್ತರ, ದಕ್ಷಿಣ ಮತ್ತು ಪೂರ್ವ ಭಾರತೀಯ ಚಾರ್ಟ್ ಸ್ವರೂಪಗಳನ್ನು ನೀಡುತ್ತೇವೆ. ಅಗತ್ಯವಿದ್ದರೆ ನೀವು ಫಾಂಟ್ ಗಾತ್ರ ಅಥವಾ ಬಣ್ಣದ ಆದ್ಯತೆಗಳನ್ನೂ ವಿನಂತಿಸಬಹುದು.",
    "discounts_question": "ಯಾವುದೇ ರಿಯಾಯಿತಿಗಳು ಲಭ್ಯವಿವೆಯೇ?",
    "discounts_answer": "ಹೌದು. ನಾವು ಋತುಮಾನದ ರಿಯಾಯಿತಿಗಳು, ಕಂಬೋ ಆಫರ್‌ಗಳು ಮತ್ತು ಜ್ಯೋತಿಷಿಗಳು ಮತ್ತು ನಿಯಮಿತ ಗ್ರಾಹಕರಿಗಾಗಿ ವಿಶೇಷ ದರಗಳನ್ನು ಒದಗಿಸುತ್ತೇವೆ. ಅಪ್ಡೇಟ್‌ಗಳಿಗಾಗಿ WhatsApp ಮೂಲಕ ಸಂಪರ್ಕದಲ್ಲಿರಿ.",
    "affiliate_question": "ಇತರರನ್ನು ಶಿಫಾರಸು ಮಾಡುವ ಮೂಲಕ ನಾನು ಗಳಿಸಬಹುದೇ?",
    "affiliate_answer": "ಹೌದು! ಶ್ರೀ ಆಸ್ಟ್ರೋ ವೇದ ಅಫಿಲಿಯೇಟ್ ಪ್ರೋಗ್ರಾಮ್‌ಗೆ ಸೇರಿ ಮತ್ತು ಸ್ನೇಹಿತರು, ಗ್ರಾಹಕರು ಅಥವಾ ನಿಮ್ಮ ಪ್ರೇಕ್ಷಕರನ್ನು ಶಿಫಾರಸು ಮಾಡುವ ಮೂಲಕ ಆಯೋಗ ಗಳಿಸಿ.",
    "languages_question": "ವರದಿಗಳು ಪ್ರಾದೇಶಿಕ ಭಾಷೆಗಳಲ್ಲಿ ಲಭ್ಯವಿವೆಯೇ?",
    "languages_answer": "ಹೌದು. ನಾವು ಹಿಂದಿ, ಇಂಗ್ಲಿಷ್, ತೆಲುಗು, ಕನ್ನಡ, ತಮಿಳು, ಮರಾಠಿ ಮತ್ತು ಬಂಗಾಳಿ ಮತ್ತು ವಿನಂತಿಯ ಮೇರೆಗೆ ಇತರ ಪ್ರಾದೇಶಿಕ ಭಾಷೆಗಳಲ್ಲಿ ವರದಿಗಳನ್ನು ನೀಡುತ್ತೇವೆ.",
    "delivery_time_question": "ನಾನು ನನ್ನ ವರದಿಯನ್ನು ಎಷ್ಟು ಬೇಗ ಸ್ವೀಕರಿಸುತ್ತೇನೆ?",
    "delivery_time_answer": "ನಿಮ್ಮ ವಿವರಗಳನ್ನು ಸಲ್ಲಿಸಿದ ೨೪ ಗಂಟೆಗಳೊಳಗೆ ನೀವು ನಿಮ್ಮ ಸಂಪೂರ್ಣ ವರದಿಯನ್ನು ಸ್ವೀಕರಿಸುತ್ತೀರಿ. WhatsApp, ಇಮೇಲ್ ಅಥವಾ SMS ಮೂಲಕ ವಿತರಣೆ ಲಭ್ಯವಿದೆ.",
    "services_question": "ಯಾವ ಜ್ಯೋತಿಷ್ಯ ಸೇವೆಗಳು ಸೇರಿವೆ?",
    "services_answer": "ನಮ್ಮ ವರದಿಗಳು ಇವುಗಳನ್ನು ಒಳಗೊಂಡಿವೆ: ಜನ್ಮ ಕುಂಡಲಿ, ಕುಂಡಲಿ ಮಿಲನ, ಲಗ್ನ ಮತ್ತು ದಶೆ ವಿಶ್ಲೇಷಣೆ, ಗೋಚರ, ನಕ್ಷತ್ರ, ಸಂಖ್ಯಾಶಾಸ್ತ್ರ, ವೃತ್ತಿ ಮತ್ತು ಪ್ರೇಮ ಮಾರ್ಗದರ್ಶನ, ವಾರ್ಷಿಕ ಮತ್ತು ದೈನಂದಿನ ಭವಿಷ್ಯವಾಣಿಗಳು, ಆರೋಗ್ಯ ಸೂಚ್ಯಂಕ, ಲಾಲ್ ಕಿತಾಬ್ ಪರಿಹಾರಗಳು, ಸಾಡೆ ಸಾತಿ ವರದಿಗಳು, ದೋಷ ವಿಶ್ಲೇಷಣೆ, ರತ್ನ ಸಲಹೆಗಳು ಮತ್ತು ಇನ್ನೂ ಹೆಚ್ಚು.",
    "unmute_first_card": "ಮೊದಲ ಕಾರ್ಡ್ ಅನ್‌ಮ್ಯೂಟ್ ಮಾಡಿ",
    "mute_first_card": "ಮೊದಲ ಕಾರ್ಡ್ ಮ್ಯೂಟ್ ಮಾಡಿ"

  };

export default translations;
